import { render, staticRenderFns } from "./alert-normal.vue?vue&type=template&id=3329cade&scoped=true&lang=pug&"
import script from "./alert-normal.vue?vue&type=script&lang=js&"
export * from "./alert-normal.vue?vue&type=script&lang=js&"
import style0 from "./alert-normal.vue?vue&type=style&index=0&id=3329cade&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3329cade",
  null
  
)

export default component.exports